// utils/request.js
import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
	baseURL: '',
	// baseURL: process.env.VUE_APP_BASE_API || 'http://dev-env.mala-internal.com/', // 你后端的基础地址
	timeout: 10000, // 请求超时时间
	headers: {
		'Content-Type': 'application/json',
		'x-biz-id':'navigation'
	}
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		// 如果有 token，可以在此统一加上
		// config.headers['Authorization'] = `Bearer ${token}`
		return config
	},
	error => {
		console.error('请求错误:', error)
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		// 可根据后端返回结构做判断
		if (res.code !== '000000') {
			console.error('接口错误:', res.message || '请求失败')
			return Promise.reject(res)
		}
		return res.data // 统一返回 data
	},
	error => {
		console.error('响应错误:', error)
		return Promise.reject(error)
	}
)

export default service